import classNames from 'classnames';
import type { ComponentProps } from 'react';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

import { fadeIn } from '../fadeIn.ts';
import { missionBackground } from '../missionBackground.ts';

const root = css`
  position: relative;
  height: 100%;
  width: 100%;
  padding: var(--double-unit);

  @media ${laptopAndAbove} {
    min-height: min(calc(90 * var(--unit)), 100vh);
  }

  &:not(.hideBackground) {
    ${missionBackground}
  }
`;

const buttonsWrapper = css`
  position: absolute;
  bottom: var(--quadruple-unit);
  left: var(--double-unit);
  right: var(--double-unit);

  opacity: 0;
  animation: ${fadeIn} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 1.35s;
`;

type Props = ComponentProps<typeof Vertical>;

export const Root = ({
  className,
  ...props
}: Omit<Props, 'center' | 'gap'>) => (
  <Vertical {...props} className={classNames(root, className)} center gap={4} />
);

export const ButtonsWrapper = ({ className, ...props }: Props) => (
  <Vertical {...props} className={classNames(buttonsWrapper, className)} />
);
